module.exports = __webpack_public_path__ + "static/media/slide_2.08eddf2d.jpg";